import { render, staticRenderFns } from "./ChainContentPosts.vue?vue&type=template&id=cbc59f4e"
import script from "./ChainContentPosts.vue?vue&type=script&lang=ts"
export * from "./ChainContentPosts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports